import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetActivityQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetActivityQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/activities/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}